import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import Navbar from '../../components/global/navbar'
import Cookies from 'universal-cookie';
import Footer from '../../components/global/footer';

function UserLayout({ user }) {
    const cookie = new Cookies();
    return (
        cookie.get('token') ?
            <>
                <Navbar user={user} />
                <Outlet />
                {/* <Footer /> */}
            </>
            :
            <>
                <Navigate to="/" replace={true} />
            </>
    )
}

export default UserLayout